export {default} from './ShadowCard';
